





















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { GenericItem } from '@/models/items/generic-item-model';

import axios from 'axios';
import { UploadUtils } from '@/utils/upload-utils';

import { PlaceItem } from '@/models/items/place-item-model';

@Component({})
export default class AddPlaceItem_Step1 extends Vue {
  public query: string = '';

  public searchResults: any[] = [];

  public searchUrl = 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates'
  public searchParams = {
    category: 'POI',
    outFields: 'PlaceName,Type,Place_Addr,City,Region,Phone,Neighborhood,URL,Type,StAddr,SubAddr,Country,Postal',
    maxLocations: 20,
    // TODO: flip to true + add api key
    forStorage: 'false',
    f: 'pjson'
  }

  public item = new PlaceItem();

  public renderEsriResponse(results: any) {
    
    this.searchResults = [];
    results.data.candidates.forEach((item: any) => {
      const placeItem = new PlaceItem();
      placeItem.title = item.attributes.PlaceName;
      placeItem.url = item.attributes.URL;
      placeItem.phonenumber = item.attributes.Phone;
      placeItem.latitude = item.location.y;
      placeItem.longitude = item.location.x;
      placeItem.country = item.attributes.Country;
      placeItem.addressLine1 = item.attributes.StAddr;
      placeItem.addressLine2 = item.attributes.SubAddr;
      placeItem.country = item.attributes.Country;
      placeItem.city = item.attributes.City;
      placeItem.state = item.attributes.Region;
      placeItem.neighborhood = item.attributes.Neighborhood;
      // placeItem.tags = [item.attributes.Type]

      this.searchResults.push(
        {
          item:placeItem,
          adddress: item.attributes.Place_Addr
        }
      );
    });
  }

  public submit() {
    const self = this;
    axios({
      url: this.searchUrl,
      params: {
        ...this.searchParams,
        singleLine: this.query
      }
    })
      .then(self.renderEsriResponse)
      .catch(function(error) {
        // handle error
        
      })
  }

  public goToNextStep(item: PlaceItem) {
    this.$emit('go-to-next-step', {
      item
    });
  }
}
